import classnames from 'classnames';
import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  id: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  truncate?: boolean;
}

const StdListCell: React.FC<Props> = ({
  id,
  children,
  style = {},
  truncate = true,
}) => {
  return (
    <StdListContext.Consumer>
      {({ id: listId }): React.ReactNode => (
        <div
          id={id}
          className={classnames(`${listId}-cell px3 font-size-4 light`, {
            truncate,
          })}
          style={style}
        >
          {children}
        </div>
      )}
    </StdListContext.Consumer>
  );
};

export default StdListCell;
